import React, { FunctionComponent, useEffect, useState } from 'react'
import styles from './style.module.css'
import { Button } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { Route } from '../../config/router'
import { Terms } from './Terms'
import { PayInFourCta } from '../PayInFourCta'
import { useAppRouter, useCheckoutToken, useCreateFacilityMutation } from '../../state'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

interface CreditFooterProps {
  contractId?: string
}

export const ApprovedCreditFooter: FunctionComponent<CreditFooterProps> = ({ contractId }) => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const [lock, setLock] = useState<boolean>(false)
  const token = useCheckoutToken()
  const [createFacility, { isLoading: isCreateFacilityLoading, isSuccess: isCreateFacilitySuccess, reset }] = useCreateFacilityMutation({
    fixedCacheKey: 'create-facility-cache',
  })
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  useEffect(() => {
    router.prefetch(Route.PAYMENT_OPTIONS)
    reset()
  }, [])

  const handleAgreeClick = async (): Promise<void> => {
    setLock(true)
    logEvent(TrackingEvent.PRESSED_CL_APPROVED_CREDIT_PAGE_CONTINUE_BUTTON)
    createFacility({ token })
  }

  useEffect(() => {
    if (isCreateFacilitySuccess) {
      router.push(Route.PAYMENT_OPTIONS)
    }
  }, [isCreateFacilitySuccess])

  return (
    <div className={styles.approvedCreditFooter}>
      <Terms documentId={contractId} />
      <div className={styles.approvedCreditAgreeButton}>
        <Button.Primary loading={isCreateFacilityLoading} disabled={lock} type='button' padding='Fluid' onClick={handleAgreeClick} testNameSpace='agree'>
          {t('consumerLending:approvedCredit:agree')}
        </Button.Primary>
      </div>
      <PayInFourCta trackingEvent={TrackingEvent.PRESSED_CL_APPROVED_CREDIT_PAGE_PAY_IN_4_BUTTON} />
    </div>
  )
}
